<label class="cigna-checkbox" data-test-id="label-checkbox">
  <input
    tabindex="0"
    (keydown.enter)="changed($event)"
    (click)="onClick($event)"
    class="form-control"
    type="checkbox"
    [id]="id"
    [name]="name"
    [checked]="checked"
    (change)="changed($event)"
    (focus)="focus.emit(true)"
    (blur)="blur.emit(true)"
    [attr.aria-labelledby]="ariaLabelledby ? ariaLabelledby : null"
    [attr.aria-describedby]="ariaDescribedby ? ariaDescribedby : null"
    [attr.aria-required]="ariaRequired ? ariaRequired : null"
    [attr.aria-invalid]="isInvalid"
    [disabled]="isDisabled"
    data-test-id="input-checkbox"
  />
  <i
    class="cigna-checkbox-img"
    [ngClass]="{
      'cigna-checkbox-img-disabled': isDisabled,
      'invalid-error': isInvalid
    }"
    data-test-id="icon-checkbox"
  ></i>
  <span
    *ngIf="label"
    class="cigna-checkbox-label"
    data-test-id="label-checkbox-text"
    [innerHtml]="label"
  ></span>
  <ng-container
    *ngIf="labelTemplate"
    [ngTemplateOutlet]="labelTemplate"
  ></ng-container>
</label>
